import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=22e6f5ae&scoped=true"
import script from "./shareDialog.vue?vue&type=script&lang=js"
export * from "./shareDialog.vue?vue&type=script&lang=js"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=22e6f5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6f5ae",
  null
  
)

export default component.exports